import { useIntl } from 'react-intl'

import { BidStatus } from '@b-stock/fe-core/bstock-next/queries'
import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

export const AuctionEndedBanner = ({
  bidStatus,
}: {
  bidStatus?: BidStatus
}) => {
  const intl = useIntl()

  const buyerLost = bidStatus === BidStatus.LOST

  return buyerLost ? (
    <Banner
      title={intl.formatMessage({
        id: 'Auction.details.auctionEnded.banner.title',
      })}
    >
      <FormattedMessage id="Auction.details.auctionEnded.banner.description" />
    </Banner>
  ) : null
}
